<template>
  <div class="relative w-full  mb-4">
    <VEmojiPicker  v-show="emojiSelector"  class=" absolute top-48 w-52 z-10 overflow-scroll" @select="selectEmoji" />
    
    <div v-show="!disable" @click="emojiSelectorClicked" class="absolute bottom-5 right-5 cursor-pointer">
      <SmileEmoji/>
    </div>

    <textarea
    :disabled="disable"
      v-model="caption"
      @input="captionUpdated($event.target.value)" 
      ref="textarea"
      class=" h-44 border-gray-200 border text-sm w-full rounded-md resize-none"
      :placeholder="placeholder"
    ></textarea>
  </div>
</template>

<script>
import { VEmojiPicker } from 'v-emoji-picker';

import SmileEmoji from '@/components/svg/SmileEmoji.vue';

export default {
  name:"TextareaEmojiPicker",

  components: {
    VEmojiPicker,
    SmileEmoji
  },

  props: {
    placeholder: {
      type: String,
      default: "Type your catchy caption here..."
    },

    disable: {
      type: Boolean,
      default: false
    },

    text: {
      type: String,
      default: ""
    },
  },

  data() {
    return {
      caption: this.text, 
      emoji: '',
      emojiSelector:false
    }
  },

  methods: {
    selectEmoji(emoji) {
      this.emoji = emoji.data;
      const self = this;
      var tArea = this.$refs.textarea;
      
      // get cursor's position:
      var startPos = tArea.selectionStart,
        endPos = tArea.selectionEnd,
        tmpStr = tArea.value;

      // insert:
      tArea.value = tmpStr.substring(0, startPos) + self.emoji + tmpStr.substring(endPos, tmpStr.length);
      tArea.focus()

      let value = this.$refs.textarea.value; 
      this.captionUpdated(value);
    },

    captionUpdated(value) {
      this.caption = value;
      this.$emit('captionChanged', value);
    },

    emojiSelectorClicked() {
      if(!this.disable) {
        this.emojiSelector=!this.emojiSelector;
      }
    }
  }
}
</script>
<style >
.container-emoji{
  height: 230px !important;
}
.emoji-picker{
  width: 100% !important;
}
.grid-emojis{
  display: block !important;
}
</style>